import { useEffect, useRef } from "react";
import L from "leaflet";
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

export default function MapViewListing({address}) {
    const mapRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) return;
        if (!address) return;

        // Fix marker
        const defaultIcon = L.icon({
            iconUrl,
            shadowUrl,
            iconSize: [25, 41],
            iconAnchor: [12, 41]
        });
        L.Marker.prototype.options.icon = defaultIcon;

        async function init() {
            // Basic geocoding using locationiq API
            const res = await fetch(
            `https://us1.locationiq.com/v1/search?key=${process.env.REACT_APP_LIQ_KEY}&q=${encodeURIComponent(address)}&format=json`
            );
            const data = await res.json();
            if (!data.length) return;
            const { lat, lon } = data[0];

            //create map
            mapRef.current = L.map(containerRef.current).setView([lat, lon], 15);

            //add tiles
            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                maxZoom: 19,
            }).addTo(mapRef.current);

            //marker
            L.marker([lat, lon]).addTo(mapRef.current);
        }

        init();

        //invalidate after layout
        setTimeout(() => {
            mapRef.current?.invalidateSize();
        }, 50);

        // Cleanup
        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
            }
        };
        }, [address]);

    return (
        <div
        ref={containerRef}
        style={{
            minHeight: "200px",
            width: "100%",
            borderRadius: "8px",
            flex: "4",
            zIndex: "1"
            }}
        />
    )
}